import { DATA_AVAILABILITY_REASON } from '../../data/constants'

const MESSAGE_ID_BY_REASON = {
  [DATA_AVAILABILITY_REASON.PERMISSION_REQUIRED]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.PERMISSION_REQUIRED',
  [DATA_AVAILABILITY_REASON.DISCOVER_NOT_COLLECTING]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.NOT_COLLECTING',
  [DATA_AVAILABILITY_REASON.DISCOVER_QUERY_FAILED]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.QUERY_FAILED',
}

export const getDiscoverUnavailableMessageId = (reason) =>
  MESSAGE_ID_BY_REASON[reason] ?? 'AI_RISK_REPORT.DATA_NOT_ASSESSED'
